module.exports = __webpack_public_path__ + "img/ES0073.7fb35574.svg";